/* Parameter names */
const nameParameterMonth: 'm' = 'm'; // Month
const nameParameterCalendar: 'c' = 'c'; // Calendar
const nameParameterPhotoSet: 'ps' = 'ps'; // Photo set
const nameParameterPhoto: 'i' = 'i'; // Image
const nameParameterQuery: 'q' = 'q'; // Query
const nameParameterCurrentPosition: 'p' = 'p'; // Position
const nameParameterCountry: 'country' = 'country';
const nameParameterLanguage: 'language' = 'language';
const nameParameterDistance: 'distance' = 'distance';
const nameParameterLimit: 'limit' = 'limit';
const nameParameterPage: 'page' = 'page';
const nameParameterSort: 's' = 's';
const nameParameterNextPlaces: 'next_places' = 'next_places';

/*
 * Export functions.
 */
export {
    nameParameterMonth,
    nameParameterCalendar,
    nameParameterPhotoSet,
    nameParameterPhoto,
    nameParameterQuery,
    nameParameterCurrentPosition,
    nameParameterCountry,
    nameParameterLanguage,
    nameParameterDistance,
    nameParameterLimit,
    nameParameterPage,
    nameParameterSort,
    nameParameterNextPlaces
}
